module.exports = {
    mobileMenu: '',
    init: function ($) {
        /* Open Menus in the mobile views */
        this.mobileMenu = $('.mobile-menu');
        window.openNav = function(temp) {
            this.mobileMenu.toggle('slide')
        }.bind(this)

        /* Open Hubspot Chat box on the click of button.*/
        window.openHubspotChat = function() {
            try {
                window.HubSpotConversations.widget.open()
            } catch(e) {
                console.log("Failed to load openup the chat window in attempt 1. Retrying in .5s.")
                setTimeout(() => {
                    window.openHubspotChat()
                }, 500)
            }
        }

        /**
         * Global Notification show hide.
         * So the idea is that when the notification is closed popup again for the day.
         */
        storedDate = localStorage.getItem('global_notificaiton_bar_closed_till');
        if (storedDate == null) {
            this.showGlobalNotificationBar($)
        }
        if (storedDate != null) {
            if (Date.parse(storedDate) < new Date()) {
                /** If the storedDate is past date then show the notification. */
                this.showGlobalNotificationBar($)
            }
        }
        /**
         * Window method to hide the global notification.
         */
        window.closeGlobalNotificationBar = function() {
            let currentDate = new Date();

            /** Change the currentDate to one day ahead. */
            currentDate.setDate(currentDate.getDate() + 1)
            $('#global-notification-bar').slideUp()
            localStorage.setItem('global_notificaiton_bar_closed_till', currentDate);
        }
    },
    /**
     * Show Global Notification Bar
     * @param {jQuery} $
     */
    showGlobalNotificationBar ($) {
        setTimeout(() => {
            $('#global-notification-bar').slideDown()
        }, 2000)
    }
};